import camelcaseKeys from 'camelcase-keys';
import {
  STORAGE_AUTH_TOKEN,
  STORAGE_DISTINCT_ID,
  MAX_AGE,
} from '~/constants/cookieStorage';
import useProfileStore from '~/store/profile';
import useAnalyticsStore from '~/store/analytics';

export function useAuthSession() {
  const tokenCookie = useCookie(STORAGE_AUTH_TOKEN, {
    maxAge: MAX_AGE,
  });
  const distinctIdCookie = useCookie(STORAGE_DISTINCT_ID, {
    maxAge: MAX_AGE,
  });

  function applyAuthSession(response, signinMethod) {
    const {
      profile,
      token: { token, distinctId },
    } = camelcaseKeys(response, { deep: true });

    tokenCookie.value = token;
    distinctIdCookie.value = distinctId;

    useProfileStore().setProfile({ profile, token, distinctId });
    useAnalyticsStore().setUserId(profile?.id);
    useAnalyticsStore().track('auth.success', { signin_method: signinMethod });
  }

  return { applyAuthSession };
}
